/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpsertMaterialContentRequestViewModel } from "../types/UpsertMaterialContentRequestViewModel.ts";

export const upsertMaterialContentRequestViewModelSchema = z.object({
  displayName: z.string().nullish(),
  content: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  parentFolderId: z.number().int().nullish(),
}) as unknown as ToZod<UpsertMaterialContentRequestViewModel>;
